module.exports = __webpack_public_path__ + "media/images/short-bettery-cce5c958696a7e0aa822a010f0e09667.svg";